



















import {Component, Mixins} from 'vue-property-decorator';
import DialogEventsMixin from '@/components/dialog/DialogEventsMixin';
import {AiCodingUpdateConfirmDialogRequest} from '@/model/CommonModel';
import CommonPromptDialog from '@/components/dialog/CommonPromptDialog.vue';
import CommonButton from '@/components/button/CommonButton.vue';

@Component({
  mixins: [DialogEventsMixin],
  components: {
    CommonPromptDialog,
    CommonButton
  }
})
export default class AiCodingUpdateConfirmDialog extends Mixins(DialogEventsMixin) {
  private onConfirm: any;
  private whoddVersion: string = '';
  private dialogVisible: boolean = false;
  private loading: boolean = false;
  private targetElement: string = '';
  private totalRow: number = 0;

  get isVisible() {
    return this.dialogVisible;
  }

  get isLoading() {
    return this.loading;
  }

  public mounted() {
    this.$modal
        .getEventBus()
        .$on('showAiCodingUpdateConfirmDialog', (params: AiCodingUpdateConfirmDialogRequest) => {
          this.show(params);
        });

    this.$modal.getEventBus().$on('hideAiCodingUpdateConfirmDialog', () => this.cancel());
  }

  public show(params: AiCodingUpdateConfirmDialogRequest) {
    this.whoddVersion = params.whoddVer ?? '';
    this.onConfirm = params.onConfirm;
    this.targetElement = params.targetElement ?? '';
    this.totalRow = params.totalRow;
    this.dialogVisible = true;
    this.loading = false;
  }

  public cancel() {
    this.dialogVisible = false;
  }

  public beforeApiCall() {
    this.loading = true;
  }

  public afterApiCall() {
    this.loading = false;
    this.dialogVisible = false;
  }

  public showEnteredElement() {
    return this.targetElement != null && this.targetElement !== '';
  }

  public showWhoddVersion() {
    return this.whoddVersion != null && this.whoddVersion !== '';
  }

  public confirm() {
    if (this.loading) {
      return;
    }

    if (this.onConfirm instanceof Function) {
      this.onConfirm(this);
    } else {
      this.cancel();
    }
  }

  public destroyed() {
    this.$modal.getEventBus().$off('showAiCodingUpdateConfirmDialog');
    this.$modal.getEventBus().$off('hideAiCodingUpdateConfirmDialog');
  }

}
